

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class CmxAboutUs extends Vue {
  HomeAboutUs: any = {};
  OurVision:any={};
  HomeContactUs:any={};
  HomeMap:any={};
  Youtube:any={};
  Facebook:any={};
  ProfessionalField:any=[];
  // 获取关于我们cms内容
  getAllContent () {
    this.$Api.cms.getContentByDevice({ key: 'HomeAboutUs', IsMobile: this.isMobile }).then(result => {
      this.HomeAboutUs = result.CMS;
    });
    this.$Api.cms.getContentByDevice({ key: 'OurVision', IsMobile: this.isMobile }).then(result => {
      this.OurVision = result.CMS;
    });
    this.$Api.cms.getContentByDevice({ key: 'HomeContactUs', IsMobile: this.isMobile }).then(result => {
      this.HomeContactUs = result.CMS;
    });
    this.$Api.cms.getContentByDevice({ key: 'Map', IsMobile: this.isMobile }).then(result => {
      this.HomeMap = result.CMS;
    });
    this.$Api.cms.getContentByDevice({ key: 'Youtube', IsMobile: this.isMobile }).then(result => {
      this.Youtube = result.CMS;
    });
    this.$Api.cms.getContentByDevice({ key: 'FB', IsMobile: this.isMobile }).then(result => {
      this.Facebook = result.CMS;
    });
  }
  // 获取关于cms内容列表
  getProfessionalField () {
    this.$Api.cms.getContentsByCatKeyEx({ Key: 'HomeProfessionalField', Page: 1, PageSize: 20, IsMobile: this.isMobile }).then((result) => {
      this.ProfessionalField = result.Data;
    });
  }
  get isMobile () {
    return this.$store.state.isMobile;
  }

  mounted () {
    this.getAllContent();
    this.getProfessionalField();
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    this.getAllContent();
    this.getProfessionalField();
  }
}
